import React, {useState, useEffect} from "react";
import {Button, Upload, message, notification } from "antd";
import {zuStandStore} from "../../zustand";
import SplitUpload from "../SplitUpload/index-websocket";
import { SyncOutlined } from "@ant-design/icons";


const allowedFileTypes = [
    "doc",
    "docx",
    "pdf",
    "ppt",
    "pptx",
    "xls",
    "xlsx",
    "application/pdf", // pdf
    "image/jpg", // jpg
    "image/png", // png
    "image/jpeg", // jpeg
    "application/zip", // zip
    "application/x-zip-compressed", // zip
    "application/msword", // doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
    "application/vnd.ms-excel", // xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
    "application/vnd.ms-powerpoint", // ppt
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
]; // 允许上传的文件类型
const UploadSingle = (props) => {
    const {
        callBack,
        isDisabled,
        contentHTml
    } = props;

    const [fileList, setFileList] = useState([])

    const handleChange = async (file, fileList) => {
        console.log(file,file.name, "文件");
        console.log(fileList, "文件列表");

        // 文件大小不超过50M
        const fileize = 10485760*5;
        if(file.size > fileize){
            message.error(`文件大小不能超过50M`);
            return false;
        }

        let fileName = file.name.split(".");
        const fileExtension = fileName[1].toLowerCase();
        const fileType = file.type;

        if (
            !allowedFileTypes.includes(fileExtension) &&
            !allowedFileTypes.includes(fileType)
        ) {
            message.error(`${file.name} 格式不符合上传类型`);
            return false;
        }
        notification.open({
            message: '文件上传中',
            placement: "top",
            duration: null,
            description: ()=>{
                return <div>{file.name} 上传中...<SyncOutlined spin /></div>
            },
        });
        
        uploadFileCallBack(fileList)

        return false;
    };

    // 上传文件执行函数
    const uploadFileCallBack = async (newFileList) => {
        await SplitUpload(newFileList, (params, socket) => {
            const {status, process, fileId, otherData, linkStatus, msg} = params || {};
            console.log("params", params);
            notification.destroy();
            if(status === "success"){
                console.log("otherData", otherData);
                callBack([
                    {
                        otherData:{...otherData},
                        name: newFileList[0].name,
                        size: newFileList[0].size,
                    }
                ])
            }else if(status === "fail"){
                message.error(msg)
                console.log("上传失败：", msg)
            }
            setFileList([])
        });
    }

 
    const upLoadProps = {
        beforeUpload: handleChange,
        showUploadList: false,
        maxCount:1
    };


    return (
        <div className="uploadFileFrame">
            <Upload
                disabled={isDisabled}
                {...upLoadProps}
                fileList={fileList}
                accept={allowedFileTypes.join(",")}
            >
                {contentHTml}
            </Upload>
        </div>
    );
};

export default UploadSingle;
